module.exports = __webpack_public_path__ + "static/media/Ryan.2f17ef77.png";